import {useSearchParams} from 'react-router-dom'

export default function useTabsUrlHandler({defaultKey} = {}) {
  const [searchParams, setSearchParams] = useSearchParams()

  let tab = searchParams.get('tab') || ''

  if (!tab && defaultKey) tab = defaultKey

  const updateURL = key => setSearchParams({tab: key})

  return {tab, updateURL}
}
